import { useAppContext } from '../contexts/AppContext'
import { PlaybooksBackendClient } from '../services/playbooksBackendClient'

/**
 * Custom hook to create an instance of PlaybooksBackendClient with the necessary configuration.
 * @returns An instance of PlaybooksBackendClient
 */
export function usePlaybooksBackendClient() {
  const { config } = useAppContext()

  if (!config?.playbooksBackendUrl || !config?.serviceBaseUrl || !config?.serviceAuthToken) {
    console.warn(
      'Playbooks Backend configuration is missing. Please ensure playbooksBackendUrl, serviceBaseUrl, and serviceAuthToken are provided in the ActionCardsConfig.',
    )
  }

  const { playbooksBackendUrl, playbooksBackendTokenEndpoint, serviceBaseUrl, serviceAuthToken } = config

  // The external environment where the AC is built in can provide a specific token endpoint
  // which can handle auth specific to that env (e.g. cookie-based auth within composer-next app).
  // If a specific token endpoint is not provided, use the one built into the meeting-service,
  // it can handle auth based on Person ID tokens and and Identity-issued OAuth tokens (#13865)
  const tokenIssuerEndpoint =
    playbooksBackendTokenEndpoint || (serviceBaseUrl ? `${serviceBaseUrl}/playbooks-token` : undefined)

  return new PlaybooksBackendClient({
    playbooksBackendUrl: playbooksBackendUrl || undefined,
    tokenIssuerEndpoint: tokenIssuerEndpoint || undefined,
    tokenIssuerApiToken: serviceAuthToken || undefined,
  })
}
